import React from "react";
import Footer from "../component/Footer";
import Navbar2 from "../component/NavbarAdmin";

const LayoutDashboard = (props) => {
  return (
    <>
      <Navbar2 />
      {props.children}
      <Footer />
    </>
  );
};

export default LayoutDashboard;
